import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=bb3dcc60&scoped=true&"
import script from "./activity.vue?vue&type=script&lang=js&"
export * from "./activity.vue?vue&type=script&lang=js&"
import style0 from "./activity.vue?vue&type=style&index=0&id=bb3dcc60&lang=scss&scoped=true&"
import style1 from "./activity.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3dcc60",
  null
  
)

export default component.exports